export const clients = {
  default: {
    logoBig: require('@/assets/medeaLogoWithText.png'),
    logoSmall: require('@/assets/medeaLogo.svg'),
    colors: {
      primary: '#F1E8FD' /* purple-20 */,
      secondary: '#2B3A5F' /* blue-90 */,
      tertiary: '#CCD9FA',
    },
    termsAndConditions:
      'https://www.medeamind.com/legal/condiciones-de-uso-y-privacidad/',
    privacyPolicy: 'https://www.medeamind.com/legal/politica-de-privacidad/',
    clientName: 'Medea',
    version: 'v2',
    saveProgress: true,
  },
  TMH: {
    logoBig: require('@/assets/TMH/logo.png'),
    logoSmall: require('@/assets/TMH/logo.png'),
    colors: {
      primary: '#FEAFC9' /* Primary-100 */,
      secondary: '#991D4F' /* Primary-700 */,
      tertiary: '#FED1E0' /* Primary-50 */,
    },
    termsAndConditions: {
      es: 'https://www.tmhsuite.com/es/terms',
      en: 'https://www.tmhsuite.com/terms',
      fr: 'https://www.tmhsuite.com/fr/terms',
      it: 'https://www.tmhsuite.com/it/terms',
      pt: 'https://www.tmhsuite.com/pt/terms',
    },
    privacyPolicy: {
      es: 'https://www.tmhsuite.com/es/policy',
      en: 'https://www.tmhsuite.com/policy',
      fr: 'https://www.tmhsuite.com/fr/policy',
      it: 'https://www.tmhsuite.com/it/policy',
      pt: 'https://www.tmhsuite.com/pt/policy',
    },
    clientName: 'TMH Suite',
    version: 'v1',
    saveProgress: false,
  },
  VIBOOD: {
    logoBig: require('@/assets/vibood/logo.png'),
    logoSmall: require('@/assets/vibood/logo.png'),
    colors: {
      primary: '#FF6C21',
      secondary: '#235970',
      tertiary: '#FFE8D9',
    },
    termsAndConditions: 'https://www.vibood.es/aviso-legal/',
    privacyPolicy: 'https://www.vibood.es/politica-de-privacidad/',
    clientName: 'ViBood',
    version: 'v2',
    saveProgress: true,
  },
  PSYPILOT: {
    logoBig: require('@/assets/psypilot/logo.png'),
    logoSmall: require('@/assets/psypilot/logoSmall.png'),
    colors: {
      primary: '#DBEAFE',
      secondary: '#1C4ED8',
      tertiary: '#F7ECFF',
    },
    termsAndConditions: 'https://www.psypilot.com/legal/terminos-y-condiciones',
    privacyPolicy: 'https://www.psypilot.com/legal/politica-de-privacidad',
    clientName: 'Psypilot',
    version: 'v2',
    saveProgress: true,
  },
  // Add new clients here
};
